import React from "react";
import PremiumUserTable from "./PremiumUsersTable";

export default function PremiumUser() {
  return (
    <div className="default-tab">
      <PremiumUserTable />
    </div>
  );
}
